module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Mitarbeitergespräche-6ae21fccdc5138ccb09479222dd85468.jpg";